var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { ArrowRightOutlined } from '@feb-team/legao-icons-react';
import { DropdownItemClsMap } from './clsMap';
import { DivTag } from '../../Utils/AtomicTag';
import { defaultDropdownItemProps } from './defaults';
var Dropdownitem = /** @class */ (function (_super) {
    __extends(Dropdownitem, _super);
    function Dropdownitem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelect = function (e) {
            // TODO
            // @ts-ignore
            var _a = _this.props, onItemSelect = _a.onItemSelect, disabled = _a.disabled, children = _a.children;
            var hasChildren = children && Array.isArray(children);
            if (hasChildren)
                return;
            if (!disabled) {
                var filterProps_1 = {};
                Object.keys(_this.props).forEach(function (item) {
                    if (typeof _this.props[item] !== 'function') {
                        filterProps_1[item] = _this.props[item];
                    }
                });
                // TODO
                //@ts-ignore
                onItemSelect(filterProps_1, e);
            }
        };
        _this.showChild = function (visible) {
            var children = _this.props.children;
            var hasChildren = children && Array.isArray(children);
            if (hasChildren) {
                clearTimeout(_this.timer);
                _this.timer = window.setTimeout(function () {
                    _this.setState({
                        visible: visible,
                    });
                }, 50);
            }
        };
        _this.renderItem = function () {
            var _a = _this.props, disabled = _a.disabled, className = _a.className, children = _a.children, title = _a.title, rest = __rest(_a, ["disabled", "className", "children", "title"]);
            var classNameStr = className + " legao-dropdown-item ";
            var itemStatus = 'normal';
            var isValidElement = false;
            var stringChild = '';
            if (disabled) {
                itemStatus = 'disabled';
            }
            if (Array.isArray(children)) {
                // @ts-ignore
                children.map(function (item) {
                    if (!React.isValidElement(item)) {
                        stringChild = children.join('');
                    }
                    else {
                        isValidElement = true;
                    }
                });
            }
            var hasChildren = children && Array.isArray(children) && isValidElement;
            return (React.createElement(DivTag, __assign({ atomics: DropdownItemClsMap[itemStatus], role: "button", className: "" + classNameStr, onClick: function (e) { return _this.handleSelect(e); }, onKeyPress: function (e) { return _this.handleSelect(e); }, onMouseOver: function () { return _this.showChild(true); }, onMouseOut: function () { return _this.showChild(false); } }, rest),
                hasChildren ? (title ? title : null) : stringChild != '' ? stringChild : children,
                hasChildren && (React.createElement(React.Fragment, null,
                    React.createElement(ArrowRightOutlined, null),
                    _this.renderChild()))));
        };
        _this.renderChild = function () {
            var _a = _this.props, children = _a.children, disabled = _a.disabled, rest = __rest(_a, ["children", "disabled"]);
            var visible = _this.state.visible;
            var childStyle = visible ? 'block' : 'none';
            var list = React.Children.map(children, function (child, index) {
                if (!child) {
                    return null;
                }
                var attribute = __assign({ key: index }, rest);
                return React.cloneElement(child, attribute);
            });
            return (React.createElement(DivTag, { atomics: ['bg-white', 'z-50', 'absolute', 'min-w-px-160', 'max-w-px-200'], className: "legao-dropdown-child", style: { display: childStyle, top: 0 } }, list));
        };
        _this.state = {
            visible: false,
        };
        _this.timer = undefined;
        return _this;
    }
    Dropdownitem.prototype.componentWillUnmount = function () {
        clearTimeout(this.timer);
    };
    Dropdownitem.prototype.render = function () {
        var levelHtml = this.renderItem();
        return React.createElement(React.Fragment, null, levelHtml);
    };
    Dropdownitem.defaultProps = defaultDropdownItemProps;
    return Dropdownitem;
}(React.PureComponent));
export default Dropdownitem;
